var _style, _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgValps = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 216.5 94.5",
    style: {
      enableBackground: "new 0 0 216.5 94.5"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#AD20FB;}\r\n")), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", {
    xmlns: "&ns_sfw;"
  }, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("sliceSourceBounds", {
    bottomLeftOrigin: "true",
    height: 91.3,
    width: 202.4,
    x: 148.1,
    y: 1.6
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.3,76.3c5.1-7.7,10.3-15.3,15.4-23c5.2-7.8,10.3-15.6,15.4-23.4c0.5-0.7,1.4-1.5,1-2.4 c-0.5-1.2-1.8-0.7-2.8-0.7c-7.1-0.1-14.2-0.2-21.2,0c-3.5,0.1-5.8-1.2-7.8-3.9c-2.9-3.8-5.9-7.5-8.9-11.2c-0.4-0.5-0.7-1.2-2-1.2 c0.9,4.1,1.8,8.2,2.7,12.2c0.5,1.9,2.1,1.8,3.6,1.8c1.8,0.1,3.6,0.5,3.6,2.7c0,2.3-1.9,2.6-3.7,2.8c-5.6,0.6-7.8-0.9-9-6.4 C9.5,18.5,8.5,13.2,7.3,8c-0.6-2.7,0.1-4.8,2.7-6C12.4,0.9,14.3,2,15.9,4c3.9,4.9,8,9.7,11.8,14.7c1.5,1.9,3.2,2.7,5.5,2.7 c7.6-0.1,15.3,0,22.9,0c2.5,0,4.8,0.2,6.3,2.6c1.6,2.6,0,4.6-1.3,6.6C50,47.2,39,63.9,27.9,80.6c-1.4,2.1-3.2,4-6.2,3.1 c-2.9-0.9-3.5-3.4-3.6-6C18,63.8,18,49.9,18.1,36c0-2,0.2-4.3,2.8-4.3c2.6,0.1,2.6,2.4,2.6,4.4c0,12.1,0,24.2,0,36.2 c0,1.2,0,2.5,0,3.7C23.8,76.1,24.1,76.2,24.3,76.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.9,65.8c0.3-6.5-0.6-14.5,0.5-22.4c1.4-10,10.8-17.9,20.9-17.4c10.8,0.5,19.2,8.6,19.8,18.9 c0.5,8.1-2.3,14.6-9.2,19c-6.9,4.5-14.2,4.6-21.4,0.7c-2.4-1.3-3.1-1-3.1,1.8c0.1,7.3,0,14.6,0,21.9c0,2.4-0.7,4.5-3.4,4.7 c-2.9,0.2-3.9-1.9-4.1-4.4c-0.1-1.1-0.1-2.3-0.1-3.4C128.9,79.1,128.9,73.2,128.9,65.8z M137.1,46.7c0,7.2,5.6,12.8,12.8,12.7 c7.2-0.1,12.6-5.7,12.5-13c-0.1-6.8-5.8-12.6-12.6-12.6C142.8,33.8,137.1,39.7,137.1,46.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.2,54c0,2.8,0,5.7,0,8.5c0,2.1-0.8,3.9-3,4.4c-2,0.5-3.6-0.2-4.5-2.2c-1-2.2-2-0.6-3-0.1 c-9.6,5-20.7,2.6-26.8-6.1c-5.1-7.3-5.2-16.5,0-23.7c5.2-7.2,14.4-10.3,23.1-7.6c7.8,2.4,13.9,10.3,14.2,18.7 C104.3,48.7,104.2,51.4,104.2,54C104.2,54,104.2,54,104.2,54z M83.7,34.3c-6.9-0.1-12.7,5.6-12.8,12.5c-0.1,6.8,5.6,12.6,12.6,12.8 c7.1,0.1,13.1-5.8,13-12.7C96.4,39.9,90.7,34.3,83.7,34.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M191.3,69.9c-4.7-0.5-9.6-0.9-14.1-3.3c-2.9-1.5-3.9-3.9-2.7-6.1c1.5-2.6,3.7-2.3,5.9-1.2 c4.2,2,8.7,2.6,13.3,2.2c2.7-0.2,5.1-1.1,5.5-4.1c0.4-3-2-4.1-4.4-4.7c-3.4-0.8-7-1.2-10.4-2.1c-6.5-1.8-9.1-4.8-9.5-10.5 c-0.3-5.1,2.6-9.7,8.1-11.9c7.5-3,15-2.5,22.2,0.9c1.9,0.9,3.5,2.3,2.9,4.8c-0.6,2.7-2.9,3.8-5.9,2.5c-3.8-1.6-7.6-2.5-11.6-2 c-2.7,0.3-5,1.2-5.3,4.3c-0.4,3.3,2,4.3,4.6,4.8c3.7,0.8,7.4,1.4,11,2.3c4.8,1.3,8.2,4.2,8.5,9.4c0.3,5-1.7,9.1-6.2,11.7 C199.6,69,195.6,69.6,191.3,69.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.6,34.9c0-6.7,0-13.4,0-20.1c0-2.2,0.5-4.1,2.8-4.9c2.7-0.9,4.9,1.1,4.9,4.8c0.1,9.9,0,19.8,0,29.7 c0,3.5,0,7.1,0,10.6c0,2.9,1.3,4.5,4.2,4.7c2.8,0.1,4.8,1.3,4.6,4.3c-0.2,3-2.6,3.3-5,3.4c-6.5,0.1-11.3-4.8-11.5-11.9 C109.5,48.5,109.6,41.7,109.6,34.9z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgValps);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/valps.f99e2c0de250cccacef10e797324fc6f.svg";